export default __webpack_public_path__ + "static/media/athleteAndManager.9295ad0f.jpg";